import { CustomerJsonType } from "reports/types";
import { ReportParams } from "reports/types";
import { useParams } from "react-router";
import { atom, useAtom } from "jotai";

// for displaying customer info on customer tiles page, store all customer jsons in an atom (too big to keep in localStorage)
export const customerInfoJsonAtom = atom<{ [ckey: string]: CustomerJsonType }>(
  {}
);
export const useCustomerInfoJsonAtom = (
  ckeyProp?: string
): CustomerJsonType | null => {
  const { ckey } = useParams() as ReportParams;
  const [allCustomerInfoJsons] = useAtom(customerInfoJsonAtom);
  return allCustomerInfoJsons[ckeyProp ?? ckey] || null;
};
